<template>
  <aside
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-3"
    :class="[
      isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3',
      computedSidebarType,
    ]"
  >
    <div class="sidenav-header">
      <button
        @click="toggleSidebar"
        class="minimize-button"
        v-if="shouldShowIcon"
        type="button"
        aria-label="Abrir ou fechar menu"
      >
        <i class="material-icons">menu</i>
      </button>

      <a class="m-0 navbar-brand d-flex justify-content-center">
        <img
          :src="logo"
          class="navbar-brand-img navbar-logo"
          alt="Rifa365"
        />
      </a>
      <div
        class="sidenav-version"
        :class="{ 'sidenav-version--on-dark': isSidebarDark }"
      >
        v{{ appVersion }}
      </div>
    </div>
    <sidenav-list />
  </aside>
</template>

<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo.png";
import { mapMutations, mapState } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
      appVersion: "",
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.appVersion = require("../../../package.json").version;
    window.addEventListener("resize", this.updateWidth);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  },
  computed: {
    ...mapState(["isRTL", "isDarkMode", "sidebarLight"]),

    computedSidebarType() {
      if (this.windowWidth < 1200) return "bg-white";
      if (this.isDarkMode && this.sidebarLight) return "bg-white";
      // Dark sólido — evita bg-transparent sumir no fundo escuro
      if (this.isDarkMode) return "sidenav-dark-solid";
      return "bg-transparent";
    },
    isSidebarDark() {
      return this.isDarkMode && this.computedSidebarType !== "bg-white";
    },
    shouldShowIcon() {
      return this.windowWidth <= 1200;
    },
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),

    updateWidth() {
      this.windowWidth = window.innerWidth;
    },

    toggleSidebar() {
      this.navbarMinimize();
    },
  },
};
</script>

<style scoped lang="scss">
.minimize-button {
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: #67748e;

  &:hover {
    color: #7b23d3;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
}

.sidenav-header {
  height: auto;
  padding-top: 0.35rem;
  padding-bottom: 0.25rem;
}

.navbar-brand {
  padding: 0.35rem 0.5rem 0.15rem;
}

.navbar-logo {
  max-height: 42px;
  width: auto;
  object-fit: contain;
}

.sidenav-version {
  text-align: center;
  font-size: 0.65rem;
  font-weight: 500;
  color: rgba(120, 120, 120, 0.85) !important;
  letter-spacing: 0.3px;
  margin-top: 0 !important;
  padding-bottom: 0.85rem;
}

.sidenav-version--on-dark {
  color: rgba(255, 255, 255, 0.5) !important;
}

#sidenav-main {
  padding: 12px;
}
</style>

<style>
body.dark-version #sidenav-main.sidenav-dark-solid {
  background: #1f283e !important;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);
}

body.dark-version #sidenav-main.bg-white {
  background: #fff !important;
}
</style>
